import React from 'react';
import {Divider} from '../Divider/Divider';
import {Typography} from '../Typography/Typography';
import {FooterContainer} from './FooterContainer';
import type {FooterContainerProps} from './FooterContainer';
import {styled} from '@mui/material/styles';
import type {DividerProps as DProps} from '../Divider/Divider';
import type {TypographyProps as TProps} from '../Typography/Typography';

export interface FooterCopyrightProps extends FooterContainerProps {
    /**
     * Change copyright text
     */
    text?: string;
    /**
     * Change copyright year.
     */
    year?: number | string;
    /**
     * Toggle copyright divider.
     */
    divider?: boolean;
    /**
     * Exposes props for the DividerProps component that wraps
     * the link.
     */
    DividerProps?: Omit<DProps, 'component'>;
    /**
     * Exposes props for the Typography component that wraps
     * the link.
     */
    TypographyProps?: TProps;
}

const currentDate = new Date();
const currentYear = currentDate.getFullYear();

const StyledType = styled(Typography)<TProps>(({theme}) => ({
    color: theme.tokens.FuelColorTextSecondary,
    textDecorationColor: theme.tokens.FuelColorTextSecondary,
    display: 'inline-block',
    width: '100%',
    textAlign: 'center'
}));

const StyledDivider = styled(Divider)<DProps>(({theme}) => ({
    backgroundColor: theme.tokens.FuelColorGray300,
    height: theme.spacing(0.5)
}));

export const FooterCopyright = React.forwardRef<any, FooterCopyrightProps>(({
    text, year = currentYear, divider, sx,
    DividerProps, TypographyProps,
    ...props
}, ref): React.ReactElement => (
    <>
        {divider && <StyledDivider {...DividerProps}/>}
        <FooterContainer
            ref={ref}
            sx={sx}
            {...props}
        >
            <StyledType
                variant='caption'
                {...TypographyProps}
            >
                {text || `Copyright \u00A9 ${year} Deere & Company. All Rights Reserved.`}
            </StyledType>
        </FooterContainer>
    </>
));

FooterCopyright.displayName = 'FooterCopyright';
